module.exports = __webpack_public_path__ + "assets/assets/images/dashboard/success-tick.8c1ad28c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/dashboard/success-tick.svg
// module id = 210
// module chunks = 0 1